import { Callout, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from '../store'

/**
 * Password Expiration Warning Banner
 * Displays a warning when the user's password is approaching expiration
 *
 * The password_warning data is returned from the API sessions controller
 * when a user logs in and their password will expire within the warning period
 * (default: 7 days)
 */
export default function PasswordExpirationWarning() {
  const { user } = useSelector((s: AppState) => s.current)
  const passwordWarning = user?.passwordWarning

  // Don't show the banner if there's no warning
  if (!passwordWarning) {
    return null
  }

  return (
    <Callout icon={IconNames.WARNING_SIGN} intent={Intent.WARNING} className="screen-only">
      <p style={{ marginBottom: 0 }}>
        <strong>Password Expiration Warning:</strong> {passwordWarning}{' '}
        <a href="/edit_account" style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
          Change your password now
        </a>
      </p>
    </Callout>
  )
}
